import { $fetch } from '@/boot/fetch'
import { $flagsmith } from '@/boot/flagsmith'

const ENDPOINT = '/paymentGateway'

export default {
  createToken({ customerId }) {
    return $fetch.peg(`${ENDPOINT}/token`, { method: 'POST', body: { customerId } })
  },
  createCustomer(customerData) {
    return $fetch.peg(`${ENDPOINT}/customer`, { method: 'POST', body: customerData })
  },
  getCustomer() {
    return $fetch.peg(`${ENDPOINT}/customer`)
  },
  updateCustomer(customerData) {
    // ℹ️ API passes the entire body thru to Braintree, so include only what is needed
    return $fetch.peg(`${ENDPOINT}/customer`, { method: 'PUT', body: customerData })
  },
  capturePayment(paymentMethodNonce) {
    return $fetch.peg(`${ENDPOINT}/capture`, { method: 'POST', body: { nonce: paymentMethodNonce } })
  },
  verifyACHMicroTransfers(verificationData) {
    return $fetch.peg(`${ENDPOINT}/ach/verify`, { method: 'POST', body: verificationData })
  },
  getACHVerificationStatus(paymentMethodToken) {
    return $fetch.peg(`${ENDPOINT}/ach/verification/${paymentMethodToken}`)
  },
  saveACHPaymentMethod({ nonce }) {
    const verificationMethod = $flagsmith.getValue('account_ach_verification_method') || null
    return $fetch.peg(`${ENDPOINT}/ach/paymentMethod`, {
      method: 'POST',
      body: { nonce, verificationMethod },
    })
  },
  generateNonce(paymentMethodToken) {
    return $fetch.peg(`${ENDPOINT}/nonce`, { method: 'POST', body: { token: paymentMethodToken } })
  },
}
